import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../config/clienteAxios";
import { updateNewService } from "../services/newsService";
import { getMultimediaNews } from "../helpers/constants";

const NewsContext = createContext();

const NewsProvider = ({ children }) => {
  const [news, setNews] = useState([]);
  const [noticia, setNoticia] = useState({});
  const [video, setVideo] = useState(null);
  const navigate = useNavigate();

  const obtenerNoticias = async (
    page,
    perPage,
    category,
    slideNews,
    multimedia,
    product,
    publish,
    visible = true,
    sortBySlideNews,
  ) => {
    try {
      const { data } = await clienteAxios("/news", {
        params: {
          page, 
          perPage, 
          category, 
          slideNews,
          visible,
          multimedia,
          product,
          publish,
          sortBySlideNews
        }
      });
      return data;
    } catch (error) {
      toast.error('Error al obtener noticias')
    }
  };
  
  const obtenerVideos = async () => {
    const videos = obtenerNoticias(...getMultimediaNews);
    return videos;
  };

  const obtenerNoticia = async ({title}) => {
    try {
      const { data } = await clienteAxios.get(`/news/${title}`);
      const video = data?.newsByParam?.find(noticia => noticia.video);
      if (video) {
        setVideo(video.video);
      }
      setNoticia(data.newsByParam[0]);
    } catch (error) {
      console.log(error);
      navigate("/error404");
    }
  };

  const crearNoticia = async (values) => {
    try {
      const { data } = await clienteAxios.post(`/news`, values);
      setNews([...news, data]);
      toast.success("Se creó la noticia con éxito");
    } catch (error) {
      toast.error("Error al crear una nueva noticia");
    }
  };
  const editNoticia = async (editNews) => {
    try {
      const { data } = await clienteAxios.put(`/news`, editNews);
      const noticiasActualizadas = news.map((noticiaState) =>
        noticiaState._id === data._id ? editNews : noticiaState
      );
      setNews(noticiasActualizadas);
      toast.success("Se actualizó la noticia");
    } catch (error) {
      toast.error("Error al actualizar la noticia");
    }
  };

  const handleVisibilitySlide = async (newInfo, field) => {
    try {
      newInfo[field] = !newInfo[field]; 
      const response = await updateNewService(newInfo._id, newInfo);
      if (response.status === 200) {
        return response.data.message;
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  const handlePublishButton = (id) => {
    const newsEdit = news.map((noticia) => {
      if (noticia._id === id) {
        editNoticia({ ...noticia, publish: true });
        return { ...noticia, publish: true };
      }
      return noticia;
    });
    setNews(newsEdit);
  };

  const editLikes = async (newslikes) => {
    try {
      const { data } = await clienteAxios.put(`news/updatelikes`, newslikes);
      const noticiasActualizadas = news.map((noticiaState) =>
        noticiaState._id === data._id ? data : noticiaState
      );
      setNews(noticiasActualizadas);
    } catch (error) {
      toast.error("Error al actualizar la noticia");
    }
  };

  const deleteNews = (id) => {
    const newsEdit = news?.map((noticia) =>
      noticia._id === id ? { ...noticia, deleted: true } : noticia
    );
    newsEdit.map(async (item) => {
      try {
        await clienteAxios.put("/news", item);
      } catch (error) {
        toast.error("error");
      }
    });
    setNews(newsEdit);
  };

  return (
    <NewsContext.Provider
      value={{
        news,
        noticia,
        obtenerNoticia,
        obtenerNoticias,
        crearNoticia,
        editNoticia,
        handlePublishButton,
        handleVisibilitySlide,
        editLikes,
        deleteNews,
        video,
        obtenerVideos
      }}
    >
      {children}
    </NewsContext.Provider>
  );
};

export { NewsProvider };

export default NewsContext;
